import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { AddMetalComponent } from '../add-metal/add-metal.component';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-list-metal',
  templateUrl: './list-metal.component.html',
  styleUrls: ['./list-metal.component.scss'],
})
export class ListMetalComponent implements OnInit {
  @Input() data;
  @Output() onChangeCart = new EventEmitter();
  cart: any = [];
  public isDesktopMode: boolean;
  public type: string;
  public category: string;
  constructor(private modalController: ModalController,
    public appMode: AppModeService,
    private translate: TranslateService,
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() {
    this.cart = this.data;
  }
   getCategory(str) {
    this.category ='';
    switch (str) {
      case "Other":
        this.category = 'buy_assets.other';
        break;
      case "coin":
        this.category = 'buy_assets.coin';
        break;
      case "bar":
        this.category = 'buy_assets.bar';
        break;
    }
    return this.category;
  }
   getType(str) {
    this.type ='';
    switch (str) {
      case "gold":
        this.type = 'buy_assets.gold_label';
        break;
      case "silver":
        this.type = 'buy_assets.silver_label';
        break;
    }
    return this.type;
  }
  editCartItem(item) {
    this.addMetalModal(item)
  }
  async addMetalModal(item?) {
    let cssClass = '';
    cssClass += (this.isDesktopMode) ? 'select-asset-modal-desktop' : 'select-asset-modal';
    const modal = await this.modalController.create({
      component: AddMetalComponent,
      componentProps: {
        editValue: item ? item : ''
      },
      cssClass,
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.9,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.6, 0.9, 1],
    });
    modal.onDidDismiss()
      .then((res) => {
        if (res) {
          this.cart.forEach(item => {
            if (item.id === res.data[0].id) {
              this.cart.splice(this.cart.indexOf(item), 1);
            }
          })
          this.cart ? this.cart.push(res.data[0]) : this.cart = res.data;
        }
        this.onChangeCart.emit(this.cart);
      });
    return await modal.present();
  }
  deleteCartItem(item) {
    this.cart = this.cart.filter(cartItem => item.id !== cartItem.id);
    this.onChangeCart.emit(this.cart);
  }
}
